import * as yup from 'yup';

export const initialValues = {
  site: '',
  reportType: '',
  name: '',
  month: '',
  year: '',
  endingInventoryCount: null,
  beginningInventoryCount: null,
  startDate: '',
  endDate: '',
  monthYear: '',
};

export const validationSchema = yup.object().shape({
  site: yup.string().required('Site is required'),
  name: yup.string().required('Name is required'),
  reportType: yup.string().required('Report Type is required'),
  monthYear: yup.string().required('Month and Year is required'),
  month: yup.string(),
  year: yup.string(),
});
